import React, { useState, useCallback } from 'react'
import { MatchAnalysisTabNav, MATabPanel } from './MatchAnalysisTabNav'
import { MATeamsTab } from './tabs/MATeamsTab'
import { MALineupTab } from './tabs/MALineupTab'
import { MAH2HTab } from './tabs/MAH2HTab'
import { MAFormTab } from './tabs/MAFormTab'
import { MATableTab } from './tabs/MATableTab'
import { MAAIInsightsTab } from './tabs/MAAIInsightsTab'
import { HistoricalFixtureModal } from './components/HistoricalFixtureModal'
import type { MatchAnalysisTab, MatchAnalysisProps } from './types'
import './styles.css'

export function MatchAnalysis({
  fixtureId,
  homeTeam,
  awayTeam,
  leagueId,
  leagueName,
  leagueLogo,
  defaultTab = 'teams',
}: MatchAnalysisProps) {
  const [activeTab, setActiveTab] = useState<MatchAnalysisTab>(defaultTab)
  const [historicalFixtureId, setHistoricalFixtureId] = useState<number | null>(null)

  const handleTabChange = useCallback((tab: MatchAnalysisTab) => {
    setActiveTab(tab)
  }, [])

  const handleFixtureClick = useCallback((clickedFixtureId: number) => {
    setHistoricalFixtureId(clickedFixtureId)
  }, [])

  const handleCloseModal = useCallback(() => {
    setHistoricalFixtureId(null)
  }, [])

  return (
    <div className="match-analysis">
      <MatchAnalysisTabNav activeTab={activeTab} onTabChange={handleTabChange} />

      <div className="match-analysis-content">
        <MATabPanel id="teams" activeTab={activeTab}>
          <MATeamsTab fixtureId={fixtureId} />
        </MATabPanel>

        <MATabPanel id="lineup" activeTab={activeTab}>
          <MALineupTab
            fixtureId={fixtureId}
            homeTeam={homeTeam}
            awayTeam={awayTeam}
          />
        </MATabPanel>

        <MATabPanel id="h2h" activeTab={activeTab}>
          <MAH2HTab
            fixtureId={fixtureId}
            homeTeam={homeTeam}
            awayTeam={awayTeam}
            onFixtureClick={handleFixtureClick}
          />
        </MATabPanel>

        <MATabPanel id="form" activeTab={activeTab}>
          <MAFormTab
            fixtureId={fixtureId}
            homeTeam={homeTeam}
            awayTeam={awayTeam}
            onFixtureClick={handleFixtureClick}
          />
        </MATabPanel>

        <MATabPanel id="table" activeTab={activeTab}>
          <MATableTab
            fixtureId={fixtureId}
            homeTeamId={homeTeam.id}
            awayTeamId={awayTeam.id}
            leagueId={leagueId}
            leagueName={leagueName}
            leagueLogo={leagueLogo}
          />
        </MATabPanel>

        <MATabPanel id="ai" activeTab={activeTab}>
          <MAAIInsightsTab fixtureId={fixtureId} />
        </MATabPanel>
      </div>

      {historicalFixtureId !== null && (
        <HistoricalFixtureModal
          fixtureId={historicalFixtureId}
          onClose={handleCloseModal}
        />
      )}
    </div>
  )
}

export default MatchAnalysis
